import { FC } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { useStripePromise } from '../../../hooks';
import { LoadingInline } from '../../Loading';

export interface StripeFormWrapperProps {
  clientSecret: string;
}

export const StripeFormWrapper: FC<StripeFormWrapperProps> = ({ children, clientSecret }) => {
  const stripePromise = useStripePromise();

  if (!clientSecret) return <LoadingInline />;

  return (
    <Elements
      stripe={stripePromise}
      options={{
        appearance: {
          rules: {
            '.Input': {
              boxShadow: 'none',
              borderRadius: '0'
            },
            '.Input:focus': {
              borderColor: '#ccf0da',
              boxShadow: 'none',
              outline: 'none'
            },
            '.Input--invalid': {
              borderColor: '#b91c1c',
              borderWidth: '1px',
              boxShadow: 'none'
            },
            '.Error': {
              color: '#b91c1c'
            }
          }
        },
        clientSecret
      }}
    >
      {children}
    </Elements>
  );
};
